import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { ca } from '@cian/analytics';
import { EBuzzoolaAnalyticsPayloadType } from '../../../enums/EBuzzoolaAnalyticsPayloadType';
var _TeaserWebBuzzoolaEvent_brand = /*#__PURE__*/new WeakSet();
export class TeaserWebBuzzoolaEvent {
  constructor(payload) {
    _classPrivateMethodInitSpec(this, _TeaserWebBuzzoolaEvent_brand);
    _defineProperty(this, "payload", void 0);
    this.payload = payload;
  }
  send(action) {
    ca('teaser', {
      product: _assertClassBrand(_TeaserWebBuzzoolaEvent_brand, this, _getProduct).call(this, action)
    });
  }
}
function _getProduct(action) {
  const {
    place,
    isSp,
    galleryPosition,
    position,
    placementId,
    traceId
  } = this.payload;
  const product = {
    extra: {
      action,
      bannerPlace: place,
      bannerSource: 'buzzoola',
      eventDate: Date.now(),
      isSp: !!isSp,
      placementId,
      traceId
    },
    name: "banner_".concat(action)
  };
  if (galleryPosition != null) {
    product.extra.galleryPosition = galleryPosition;
  }
  if (position != null) {
    product.position = position;
  }
  switch (this.payload.type) {
    case EBuzzoolaAnalyticsPayloadType.WithBuzzoolaData:
      {
        const {
          campaignId,
          creativeId,
          jsonFields,
          hitUrl,
          title,
          description
        } = this.payload;
        product.id = creativeId;
        Object.assign(product.extra, {
          campaignId,
          hitUrl
        });
        if (title) {
          product.extra.creativeTitle = title;
        }
        if (description) {
          product.extra.creativeText = description;
        }
        if (jsonFields.objectId) {
          product.extra.dealType = jsonFields.dealType || 'sale';
          product.extra.objectType = jsonFields.objectType || 'jk';
          product.extra.objectId = jsonFields.objectId;
        }
        if (jsonFields.builderId) {
          product.extra.builderId = jsonFields.builderId;
        }
        break;
      }
    case EBuzzoolaAnalyticsPayloadType.WithBuzzoolaErrorData:
      {
        const {
          errorMessage,
          errorName,
          errorType
        } = this.payload;
        Object.assign(product.extra, {
          errorMessage,
          errorName,
          errorType
        });
        break;
      }
  }
  return product;
}